import { memoizeFunction } from "@fluentui/react/lib/Utilities";
import { mergeStyles } from "@fluentui/react/lib/Styling";

export const getWrapperStyles = memoizeFunction((): string => {
  return mergeStyles({
    display: "inline-block",
    width: "max-content",
  });
});
